import { useState } from 'react';
import {
  ConfirmDialog,
  SingleFieldDialog,
  type TConfirmDialogState,
  type TSingleFieldDialogState,
} from '@shared/components';
import { AccessDialog, type TAccessDialogState } from '@modules/access';
import { useGeneralActions } from './useActions.hook';

const useRootItemActions = () => {
  const [singleFieldDialogState, setSingleFieldDialogState] = useState<TSingleFieldDialogState<'input'>>();
  const [confirmDialogState, setConfirmDialogState] = useState<TConfirmDialogState>();
  const [accessDialogState, setAccessDialogState] = useState<TAccessDialogState>();

  const actions = useGeneralActions({
    setSimpleDialogState: setSingleFieldDialogState,
    setConfirmDialogState,
    setAccessDialogState,
  });

  const rootItemDialogs = (
    <>
      <SingleFieldDialog state={singleFieldDialogState} setState={setSingleFieldDialogState} />
      <ConfirmDialog state={confirmDialogState} setState={setConfirmDialogState} />
      <AccessDialog state={accessDialogState} setState={setAccessDialogState} />
    </>
  );

  return { actions, rootItemDialogs };
};

export { useRootItemActions };
